import { useEffect, useRef, useState } from "react";
import { ExploreClubView } from "./ExploreClubView";
import { createUrl, post } from "../../network/AxiosInterceptor";

const ExplorerClub = () => {
  const trips = useRef([]);
  const [tripData, setTripData] = useState([]);

  useEffect(() => {
    window.scrollTo(0, 0);
    fetchAllTrips();
  }, []);

  const fetchAllTrips = async () => {
    post(createUrl(`/api/trips/listing`), {})
      .then((response) => {
        trips.current = response.data.trips;
        setTripData(response.data.trips);
      })
      .catch(function (error) {
        console.log(error);
      });
  };

  return (
    <div>
      <ExploreClubView tripData={tripData} />
    </div>
  );
};

export default ExplorerClub;
